import { formatMoney as formatAsMoney } from '@shopify/theme-currency';

const { money } = window.settings;

const { moneyFormat } = money;

const formatMoney = (price, format = moneyFormat) =>
  formatAsMoney(price, format);

export default formatMoney;
